export default __webpack_public_path__ + "static/media/ownerrez_step7.0844ad6a.jpg";